export const regionToCountryCode = {
  "us-east-1": "US",
  "us-west-1": "US",
  "us-west-2": "US",
  "eu-west-1": "IE",
  "eu-west-2": "GB",
  "eu-central-1": "DE",
  "eu-north-1": "SE",
  "ap-southeast-1": "SG",
  "ap-northeast-1": "JP",
  "ap-south-1": "IN",
  "sa-east-1": "BR",
  "ca-central-1": "CA",
  "me-south-1": "BH",
  "af-south-1": "ZA",
};

export const getCountryCodeFromRegion = (regionOrAz) => {
  const region = regionOrAz.replace(/[a-z]$/, ""); // Remove trailing AZ letter if present

  const map = {
    "us-east-1": "US",
    "us-west-1": "US",
    "us-west-2": "US",
    "eu-west-1": "IE",
    "eu-west-2": "GB",
    "eu-central-1": "DE",
    "eu-north-1": "SE",
    "ap-southeast-1": "SG",
    "ap-northeast-1": "JP",
    "ap-south-1": "IN",
    "sa-east-1": "BR",
    "ca-central-1": "CA",
    "me-south-1": "BH",
    "af-south-1": "ZA",
    // Add more as needed
  };

  return map[region];
};
